import { Flex, Grid, HStack, Icon, Span, Spinner, Square, Text } from '@chakra-ui/react'
import { EditBoxIcon } from '@editor/assets/icons'
import { InspectionArea } from '@editor/interfaces/inspection'
import { parseInspectionItemPartitionKey } from '@editor/services/InspectionArea'
import { RootState, useAppDispatch } from '@editor/store/app'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'

import { setInspectionAreaIdToEdit } from '../store'

const InspectionAreaRowHeader = ({ inspectionArea }: { inspectionArea: InspectionArea }) => {
  // Store
  const dispatch = useAppDispatch()
  const isSaving = useSelector((state: RootState) => state.inspectionSheet.isSaving)
  const isSavingSettings = useSelector((state: RootState) => state.inspectionSheet.isSavingSettings)
  const isBatchSaving = useSelector((state: RootState) => state.editor.isBatchSaving) // re-using this for inspection group saving.
  const isAllowedToModifySheet = useSelector((state: RootState) => state.inspectionSheet.isAllowedToModifySheet)

  const inspectionSheet = useSelector((state: RootState) => state.inspectionSheet.inspectionSheets).find((sheet) => {
    const ids = parseInspectionItemPartitionKey(sheet.partition_key || '') // items and sheet have same format so it can be re-used.
    return ids.inspectionAreaId === inspectionArea.inspection_area_id
  })

  const editedInspectionSheets = useSelector((state: RootState) => state.inspectionSheet.editedInspectionSheets)
  const editedInspectionSheet = editedInspectionSheets.find((sheet) => {
    const ids = parseInspectionItemPartitionKey(sheet.partition_key || '')
    return ids.inspectionAreaId === inspectionArea.inspection_area_id
  })

  const editedInspectionAreas = useSelector((state: RootState) => state.inspectionSheet.editedInspectionAreas)
  const editedInspectionArea = editedInspectionAreas.find(
    (area) => area.inspection_area_id === inspectionArea.inspection_area_id,
  )

  return (
    <Flex className="inspection-area-header">
      <Flex className="inspection-area-title">
        {isAllowedToModifySheet && (
          <Square
            onClick={() => {
              dispatch(setInspectionAreaIdToEdit(inspectionArea.inspection_area_id))
            }}
          >
            <Icon boxSize={5} asChild>
              <EditBoxIcon />
            </Icon>
          </Square>
        )}
        <Span>{editedInspectionArea?.inspection_area_name || inspectionArea?.inspection_area_name}</Span>
      </Flex>
      <Grid className="inspection-area-properties" fontSize="sm">
        <Text>
          <Span>工種名</Span>
          <Span>
            {(editedInspectionSheet
              ? editedInspectionSheet.construction_properties.construction_type
              : inspectionSheet?.construction_properties.construction_type) || ''}
          </Span>
        </Text>
        <Text>
          <Span>種別</Span>
          <Span>
            {(editedInspectionSheet
              ? editedInspectionSheet.construction_properties.construction_type_detailed
              : inspectionSheet?.construction_properties.construction_type_detailed) || ''}
          </Span>
        </Text>
        <Text>
          <Span>作成者</Span>
          <Span>
            {(editedInspectionSheet ? editedInspectionSheet.creator_name : inspectionSheet?.creator_name) || ''}
          </Span>
        </Text>
        <Text>
          <Span>作成日</Span>
          <Span>
            {editedInspectionSheet?.create_time_user_specified ||
            (!editedInspectionSheet && inspectionSheet?.create_time_user_specified)
              ? dayjs(
                  editedInspectionSheet?.create_time_user_specified || inspectionSheet?.create_time_user_specified,
                ).format('YYYY/MM/DD')
              : ''}
          </Span>
        </Text>
        <Text>
          <Span>立会者</Span>
          <Span>{editedInspectionSheet?.observer_name || inspectionSheet?.observer_name || ''}</Span>
        </Text>
        <Text>
          <Span>立会日</Span>
          <Span>
            {editedInspectionSheet?.observe_time_user_specified ||
            (!editedInspectionSheet && inspectionSheet?.observe_time_user_specified)
              ? dayjs(
                  editedInspectionSheet?.observe_time_user_specified || inspectionSheet?.observe_time_user_specified,
                ).format('YYYY/MM/DD')
              : ''}
          </Span>
        </Text>
      </Grid>
      <HStack
        color="gray2.500"
        alignItems="center"
        justifyContent="end"
        pr={4}
        fontWeight={700}
        className="saving-indicator"
      >
        {(isSaving || isSavingSettings || isBatchSaving) && (
          <>
            <Spinner />
            <Text>保存中...</Text>
          </>
        )}
      </HStack>
    </Flex>
  )
}

export default InspectionAreaRowHeader
